import { BaseQuery, NonAbapQuery } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

export const useEmailTemplate = () => {
  const { t } = useTranslation();

  const getNonAbapEmailBody = (query: BaseQuery, href: string) => {
    const queryDetails = query?.queryDetails as NonAbapQuery;

    return t('email-table-ui-query', {
      href,
      project: query?.project.projectName || '',
      sourceText: query?.sourceText || '',
      issue: t(query?.issueType || ''),
      repository: queryDetails.repository || '',
      fileName: queryDetails.fileName || '',
      stringId: queryDetails.stringId || ''
    });
  };

  const getGenericEmailBody = (query: BaseQuery, href: string) => {
    return t('email-table', {
      href,
      project: query?.project.projectName || '',
      sourceText: query?.sourceText || '',
      issue: t(query?.issueType || '')
    });
  };

  const getEmailBody = (query: BaseQuery, href: string) => {
    switch (query?.queryDetails?.__typename) {
      case 'NonAbapQuery':
        return getNonAbapEmailBody(query, href);
      case 'DitaQuery':
      case 'TrainingQuery':
      default:
        return getGenericEmailBody(query, href);
    }
  };

  const getEmailTemplate = (query: BaseQuery, href: string) => {
    const queriesHref = `${location.origin}/queries`;
    const emailTable = getEmailBody(query, href);

    return t('email-body', { emailTable, queriesHref });
  };

  return { getEmailBody, getEmailTemplate };
};
